<template>
  <div>
    <div
      v-if="shown"
      class="qr-reader"
    >
      <v-btn
        icon
        dark
        absolute
        top
        right
        @click="$emit('update:shown', false)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
        class="qr-reader__loader"
      />
      <qrcode-stream
        class="qr-reader__stream"
        :track="paintOutline"
        :paused="paused"
        :torch="torch"
        @decode="onDecode"
        @init="onInit"
      />
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import { mapMutations } from 'vuex';

export default {
  name: 'QRCodeReader',
  components: {
    QrcodeStream,
  },
  model: {
    prop: 'shown',
    event: 'update:shown',
  },
  props: {
    shown: {
      type: Boolean,
      default: false,
    },
    torch: {
      type: Boolean,
      default: false,
    },
    paused: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    shown(val) {
      this.toggleScanning(val);
    },
  },
  destroyed() {
    this.toggleScanning(false);
  },
  methods: {
    ...mapMutations(['toggleScanning']),
    onDecode(result) {
      if (result) {
        setTimeout(() => {
          this.$emit('decode', result.trim());
        }, 500);
      }
    },
    async onInit(promise) {
      promise.catch((error) => {
        let errorMessage;

        switch (error.name) {
          case 'NotAllowedError':
            errorMessage = 'Для работы с приложением предоставьте ему права доступа к камере в настройках вашего браузера';
            break;
          case 'NotFoundError':
            errorMessage = 'Камера не найдена';
            break;
          case 'NotSupportedError':
            errorMessage = 'Небезопасное соединение! (Требуется https, localhost)';
            break;
          case 'NotReadableError':
            errorMessage = 'Возможно, камера уже используется другим приложением';
            break;
          case 'OverconstrainedError':
            errorMessage = 'Установленная камера не поддерживается приложением';
            break;
          case 'StreamApiNotSupportedError':
            errorMessage = 'Ваш браузер не поддерживается приложением';
            break;
          default:
            errorMessage = 'Неизвестаня ошибка';
        }

        console.log(errorMessage); // eslint-disable-line

        // this.$store.commit('showErrorMessage', errorMessage);
        // window.appInsights.trackException(error, 'camera error handler', { errorMessage });
      });
    },
    paintOutline(detectedCodes, ctx) {
      detectedCodes.forEach((detectedCode) => {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;

        ctx.strokeStyle = 'red';
        ctx.lineWidth = 2;

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        otherPoints.forEach(({ x, y }) => {
          ctx.lineTo(x, y);
        });
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      });
    },
  },
};
</script>

<style lang="scss">
.qr-reader {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background: black;
  z-index: 200;

  &__loader {
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .qrcode-stream-wrapper {
    width: 100%;
    height: auto;
    margin-top: auto;
    margin-bottom: auto;
  }
}

.error {
    font-weight: bold;
    color: red;
}
</style>
